export default __webpack_public_path__ + "static/media/logonama.bdd842b1.png";